import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import './style.scss';

export class ProfileTab {
    $onChanges() {
        const candidateRecruiter = _.get(this.candidate, 'workflow.recruiterId');

        this.canEdit = candidateRecruiter && candidateRecruiter === this.recruiterId;
        this.arePreferencesExist = _.get(this.candidate, 'preferences.0');
    }
}

export const ProfileTabConfiguration = {
    template,
    bindings: {
        candidate: '=',
        recruiterId: '<'
    },
    controller: ProfileTab,
    controllerAs: 'candidateProfileTabCtrl',
};

angular.module('TALENYA-FE').component('candidateProfileTab', ProfileTabConfiguration);